module.exports = __webpack_public_path__ + "static/media/SUSD-logo.a7493658.png";